:host {
  /* Component styles go here */
}

.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  .item {
    position: relative;
  }

  @include breakpointMin("md") {
    grid-template-columns: repeat(6, 1fr);

    .small {
      grid-column: auto / span 2;
    }

    .medium {
      grid-column: auto / span 3;
    }

    .large {
      grid-column: auto / span 6;
    }
  }
}

img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 0.5rem;
}
